import { FC, useEffect, useState } from "react";
import { TAB_ANALYTICS, TAB_ANALYTICS_INNER } from "constants/paths";
import styled from "styled-components";
import AnalyticsHeaderSticky from "./AnalyticsHeaderSticky";
import AnalyticsDashboard from "../Dashboard/AnalyticsDashboard";
import AnalyticsFilters from "modules/Analytics/Shared/AnalyticsFilters";
import AnalyticsContent from "../Content/AnalyticsContent";
import StyledWrapper from "./StyledWrapper";
import {
  getAnalyticsCampaignsAssetsList,
  // getDefaultCampaigns,
  getDashboardData,
  resetAnalyticsGraphData,
  resetSelectedCampaigns,
  resetSelectedEmails,
  resetShareProfileDailyIQandWeeklyAccountsFilter,
  setCampaignsFilter,
  setFirstTimeAllDataShown,
  setDefaultFlag,
  setRenderDone,
} from "../Dashboard/actions";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import ContactsWrapper from "../Contacts/ContactsWrapper";
import AccountTabsRouting from "modules/Analytics/Accounts/AccountTabsRouting";
import store, { RootState } from "store";
import { exitAnalyticsWrapper } from "../utils";
import CustomReports from "../Insights/CustomReports";
import { useSelector } from "react-redux";
import { resetFilterbyContacts } from "../Contacts/action";
import {
  ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS,
  ANALYTICS_CARD_DATA,
  ANALYTICS_DASHBOARD,
  ANALYTICS_DASHBOARD_GRAPH_DATA,
  GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST,
} from "constants/types";
import Insights from "../Insights/Insights";

interface IAnalyticsWrapper {
  page: string;
  tab: string;
}

export const AnalyticsWrapper: FC<IAnalyticsWrapper> = (props) => {
  const { page, tab } = props;
  const campaignId = getQueryCampaignId();
  const emailId = getQueryEmailId();
  sessionStorage.setItem("campaignIdForBackButton", campaignId.toString());
  const innerTabs = [TAB_ANALYTICS_INNER.DASHBOARD, TAB_ANALYTICS_INNER.CONTENT];

  const [searchedText, setSearchedText] = useState("");

  const selectedCampaignsIds = useSelector((state: RootState) => state.analyticsDashboard.selectedCampaignsIds);
  const selectedAssetsIds = useSelector((state: RootState) => state.analyticsDashboard.selectedAssetsIds);
  const campaign_count = useSelector((state: RootState) => state.accountsDashboard.campaign_count);
  const campaignsLength = useSelector((state: RootState) => state.analyticsDashboard.campaigns.length);
  const email_count = useSelector((state: RootState) => state.accountsDashboard.email_count);
  const firstRenderDone = useSelector((state: RootState) => state.analyticsDashboard.firstRenderDone);

  const AllCampaignsFilterCheck = useSelector(
    (state: RootState) => state.analyticsDashboard.campaignsFilters.isAllCampaigns
  );
  const { isShareProfile, isDailyIQ, isWeeklyAccountInsights } = useSelector(
    (state: RootState) => state.analyticsDashboard
  );

  useEffect(() => {
    // if in the reducer state campaigns don't have the data then only fire the loading action.
    if (!campaignsLength) {
      store.dispatch({
        type: GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST.LOAD,
      });
    }
    return () => {
      setRenderDone();
      setDefaultFlag();
      store.dispatch({ type: ANALYTICS_DASHBOARD_GRAPH_DATA.RESET_DATES });
      store.dispatch({ type: ANALYTICS_DASHBOARD.RESET_APPLIED_CAMPAIGN_FILTERS });
      // resetAllTabsFilter(false);
    };
  }, []);

  useEffect(() => {
    getDashboardData(firstRenderDone);
  }, [firstRenderDone]);

  useEffect(() => {
    getAnalyticsCampaignsAssetsList();
    // if (campaignId && emailId) {
    //   setSelectedCampaignAndEmailId(campaignId, emailId);
    // }
    return () => {
      const paramsRemoved = store.getState().analyticsDashboard.queryParamsRemoved;
      if (paramsRemoved) {
        store.dispatch({
          type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.REMOVE_QUERY_PARAMS_UNSET,
        });
      } else {
        resetAnalyticsGraphData();
        sessionStorage.removeItem("campaignIdForBackButton");
        sessionStorage.removeItem("fromSentEmail");
        exitAnalyticsWrapper();
        if (campaignId && emailId) {
          resetSelectedCampaigns();
          resetSelectedEmails();
        }
        let isAllCampaigns = store.getState().analyticsDashboard.appliedCampaignsFilters.isAllCampaigns;
        let { isShareProfile, isDailyIQ, isWeeklyAccountInsights } =
          store.getState().analyticsDashboard.appliedCampaignsFilters;
        if (isAllCampaigns) {
          setCampaignsFilter({ isAllCampaigns: false });
        }

        if (isShareProfile || isDailyIQ || isWeeklyAccountInsights) {
          resetShareProfileDailyIQandWeeklyAccountsFilter();
        }
        setFirstTimeAllDataShown(false);
        setDefaultFlag();
        setRenderDone();
        resetFilterbyContacts();
      }
    };
  }, [campaignId, emailId]);

  useEffect(() => {
    store.dispatch({ type: ANALYTICS_DASHBOARD.RESET_CAMPAIGN_FILTERS });
  }, [page]);

  // useEffect(() => {
  //   if (page !== undefined && !emailId && !campaignId) {
  //     let object: any = {
  //       allCampaigns: false,
  //     };
  //     // getDefaultCampaigns(object);
  //   }
  // }, []);

  return (
    <Wrapper>
      {/* Common Header Component for Analytics Pages */}
      {
        <div>
          <AnalyticsHeaderSticky page={page} tab={tab} />
          {page === TAB_ANALYTICS.ACCOUNTS &&
            innerTabs?.includes(tab) &&
            (campaign_count > 0 || selectedCampaignsIds?.length > 0) && (
              <div className="showing-results">
                {isShareProfile ? (
                  <>Showing results for Shared Profiles</>
                ) : isDailyIQ ? (
                  <>Showing results for Daily IQ</>
                ) : isWeeklyAccountInsights ? (
                  <>Showing results for Weekly Account Insights</>
                ) : AllCampaignsFilterCheck === true ? (
                  <>Showing results for All Campaigns</>
                ) : (
                  <>
                    Showing results for{" "}
                    {selectedCampaignsIds?.length > 0
                      ? selectedCampaignsIds?.length
                      : `top ${campaign_count > 4 ? "4" : campaign_count}`}{" "}
                    Campaign(s) and {selectedAssetsIds?.length > 0 ? selectedAssetsIds?.length : `${email_count}`}{" "}
                    Email(s)
                  </>
                )}
              </div>
            )}
          <StyledWrapper>
            <AnalyticsFilters
              page={page}
              searchedText={searchedText}
              tab={tab}
              hidden={
                ((page === TAB_ANALYTICS.CONTACTS || page === TAB_ANALYTICS.ACCOUNTS) &&
                  innerTabs.includes(tab ?? "")) ||
                page === TAB_ANALYTICS.INSIGHTS
              }
            />
            {page === undefined || page === "/" ? (
              <AnalyticsDashboard page={page} tab={tab} />
            ) : page === TAB_ANALYTICS.ACCOUNTS ? (
              <AccountTabsRouting tab={tab} setSearchedText={setSearchedText} searchedText={searchedText} />
            ) : page === TAB_ANALYTICS.CONTACTS ? (
              <ContactsWrapper
                page={page}
                tab={tab}
                setSearchedText={setSearchedText}
                searchedText={searchedText}
              />
            ) : page === TAB_ANALYTICS.CONTENT ? (
              <AnalyticsContent setSearchedText={setSearchedText} searchedText={searchedText} />
            ) : page === TAB_ANALYTICS.TRENDS ? (
              // <CustomReports />
              <Insights tab={tab} />
            ) : page === TAB_ANALYTICS.INSIGHTS ? (
              <CustomReports />
              // <Insights tab={tab} />
            ) : (
              <AnalyticsDashboard />
            )}
          </StyledWrapper>
        </div>
      }
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 70px 90px 0 90px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 50px 65px 0 65px;
  }
  .showing-results {
    margin-top: 14px;
    color: #5e7079;
    font-weight: 700;
    font-family: "Roboto", sans-serif;
    font-size: 18px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  h3 {
    color: #424b50;
    font-size: 23px;
    font-weight: 600;
    margin: 0 0 10px 0;
    display: block;
    font-family: "Roboto Slab", serif;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
  }
  .email-name-box .email-name {
    max-width: 100% !important;
  }
  .tabs-wrapper {
    .dropdown-selecter {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        min-width: 190px !important;
      }
    }
  }
`;
